import React, { useEffect, useState } from "react";
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { Link, useNavigate } from "react-router-dom";
import { doSignOut } from "../../firebase/auth";
import { ChevronDownIcon, PowerIcon } from "@heroicons/react/20/solid";
import { useAuth } from "../../contexts/authContext/";
// import { getFunctions, httpsCallable } from "firebase/functions";
import { app } from "../../firebase/firebase";
import { getCurrentUserSubscription } from "@invertase/firestore-stripe-payments";
import { viewRecord } from "../../firebase/db/users/crud.tsx";
import LetteredAvatar from "react-lettered-avatar";
// npm in

export default function UserMenu() {
	const navigate = useNavigate();
	const { currentUser } = useAuth();
	console.log("currentUser: " + currentUser.uid);
	const [profileUrl, setProfileUrl] = useState("");
	const [artistName, setArtistName] = useState("");

	useEffect(() => {
		const fetchDataAndSetState = async () => {
			try {
				console.log("Fetching data...");
				if (currentUser && currentUser.uid) {
					console.log("Current User ID:", currentUser.uid);
					const fetchedData = await viewRecord(currentUser.uid);
					if (fetchedData !== null) {
						setProfileUrl(fetchedData.profile_url);
						setArtistName(fetchedData.artist_name);
					} else {
						setProfileUrl(null);
					}
				}
			} catch (e) {
				// setError(e); //More informative error message
			} finally {
				// setIsLoading(false);
			}
		};

		fetchDataAndSetState();
	}, [currentUser]);

	if (currentUser) {
		return (
			<Menu as="div" className="relative inline-block text-left">
				<div>
					<MenuButton className="inline-flex w-full justify-center border-none gap-x-1.5 rounded-md px-3 py-2 shadow-xs ">
						{/* Options */}
						{/* <ChevronDownIcon aria-hidden="true" className="-mr-1 size-5 text-gray-400" />*/}
						{profileUrl ? (
							<img className="w-[40px] h-[40px] rounded-full" src={profileUrl} alt={artistName} />
						) : (
							<LetteredAvatar size={40} radius={20} name={artistName} />
						)}
					</MenuButton>
				</div>
				<MenuItems
					transition
					className="absolute right-0 z-10 mt-2 w-56 origin-top-right divide-y divide-gray-100 rounded-md bg-white ring-1 shadow-lg ring-black/5 transition focus:outline-hidden data-closed:scale-95 data-closed:transform data-closed:opacity-0 data-enter:duration-100 data-enter:ease-out data-leave:duration-75 data-leave:ease-in">
					<div className="py-1">
						<MenuItem>
							<button
								onClick={() => navigate("/profile")}
								className="block px-4 py-2 text-sm text-gray-700 data-focus:bg-gray-100 data-focus:text-gray-900 data-focus:outline-hidden">
								Profile
							</button>
						</MenuItem>
					</div>
					<div className="py-1">
						<MenuItem>
							<button
								// onClick={generatePortalLink(currentUser.uid)}
								className="block px-4 py-2 text-sm text-gray-700 data-focus:bg-gray-100 data-focus:text-gray-900 data-focus:outline-hidden">
								Billing
							</button>
						</MenuItem>
					</div>
					<div className="py-1">
						<MenuItem>
							<button
								onClick={() => {
									doSignOut().then(() => {
										navigate("/login");
									});
								}}
								className="block px-4 py-2 text-sm text-gray-700 data-focus:bg-gray-100 data-focus:text-gray-900 data-focus:outline-hidden">
								<div class="flex items-center">
									<PowerIcon aria-hidden="true" className="-mr-1 mr-2 size-5 text-gray-400" />
									Logout
								</div>
							</button>
						</MenuItem>
					</div>
				</MenuItems>
			</Menu>
		);
	}
}
